function SvgComponent(props) {
    return (
        <svg
            style={{
                width: props.isDesktop ? '200px' : '106px'
            }}
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
            viewBox="0 0 422.01 165.13"
            {...props}
        >
            <defs>
                <linearGradient
                    id="prefix__c"
                    x1={104.96}
                    y1={45.07}
                    x2={104.96}
                    y2={82.66}
                    gradientUnits="userSpaceOnUse"
                >
                    <stop offset={0} stopColor="#6559a0" />
                    <stop offset={0.06} stopColor="#605fa5" />
                    <stop offset={0.7} stopColor="#2c9dd7" />
                    <stop offset={1} stopColor="#17b6eb" />
                </linearGradient>
                <linearGradient
                    id="prefix__d"
                    x1={117.5}
                    y1={52.27}
                    x2={104.49}
                    y2={61.14}
                    gradientUnits="userSpaceOnUse"
                >
                    <stop offset={0.5} stopColor="#9a9899" />
                    <stop offset={0.55} stopColor="#aaa8a9" />
                    <stop offset={0.68} stopColor="#cfcece" />
                    <stop offset={0.81} stopColor="#e9e9e9" />
                    <stop offset={0.92} stopColor="#f9f9f9" />
                    <stop offset={1} stopColor="#fff" />
                </linearGradient>
                <linearGradient
                    id="prefix__e"
                    x1={101.73}
                    y1={34.27}
                    x2={114.01}
                    y2={58.74}
                    gradientUnits="userSpaceOnUse"
                >
                    <stop offset={0} stopColor="#934b96" />
                    <stop offset={0.05} stopColor="#8f4e98" />
                    <stop offset={0.42} stopColor="#7461a7" />
                    <stop offset={0.75} stopColor="#646db1" />
                    <stop offset={1} stopColor="#5e71b4" />
                </linearGradient>
                <linearGradient
                    id="prefix__f"
                    x1={179.62}
                    y1={36.93}
                    x2={195.16}
                    y2={85.99}
                    gradientUnits="userSpaceOnUse"
                >
                    <stop offset={0} stopColor="#fcc90b" />
                    <stop offset={0.23} stopColor="#f5970f" />
                    <stop offset={0.6} stopColor="#ea4b14" />
                    <stop offset={0.87} stopColor="#e31a18" />
                    <stop offset={1} stopColor="#e00819" />
                </linearGradient>
                <linearGradient
                    id="prefix__g"
                    x1={163.33}
                    y1={85.69}
                    x2={176.22}
                    y2={49.27}
                    gradientUnits="userSpaceOnUse"
                >
                    <stop offset={0} stopColor="#c4d10b" />
                    <stop offset={1} stopColor="#f49b0b" />
                </linearGradient>
                <linearGradient
                    id="prefix__a"
                    x1={183.02}
                    y1={46.47}
                    x2={175.42}
                    y2={53.83}
                    gradientUnits="userSpaceOnUse"
                >
                    <stop offset={0.1} stopColor="#828384" />
                    <stop offset={0.28} stopColor="#a8a9aa" />
                    <stop offset={0.5} stopColor="#cececf" />
                    <stop offset={0.69} stopColor="#e9e9e9" />
                    <stop offset={0.87} stopColor="#f9f9f9" />
                    <stop offset={1} stopColor="#fff" />
                </linearGradient>
                <linearGradient
                    id="prefix__h"
                    x1={155.85}
                    y1={35.38}
                    x2={143.79}
                    y2={75.69}
                    gradientUnits="userSpaceOnUse"
                >
                    <stop offset={0} stopColor="#c4d10b" />
                    <stop offset={1} stopColor="#49bac5" />
                </linearGradient>
                <linearGradient
                    id="prefix__i"
                    x1={137.1}
                    y1={69.2}
                    x2={146.33}
                    y2={65.76}
                    xlinkHref="#prefix__a"
                />
                <linearGradient
                    id="prefix__j"
                    x1={101.79}
                    y1={21.04}
                    x2={141.78}
                    y2={73.44}
                    gradientUnits="userSpaceOnUse"
                >
                    <stop offset={0} stopColor="#31abe2" />
                    <stop offset={1} stopColor="#89c7b4" />
                </linearGradient>
                <linearGradient
                    id="prefix__k"
                    x1={86.81}
                    y1={35.38}
                    x2={74.75}
                    y2={75.69}
                    gradientUnits="userSpaceOnUse"
                >
                    <stop offset={0} stopColor="#e20e7e" />
                    <stop offset={1} stopColor="#8b1e80" />
                </linearGradient>
                <linearGradient
                    id="prefix__l"
                    x1={68.06}
                    y1={69.2}
                    x2={77.29}
                    y2={65.76}
                    gradientUnits="userSpaceOnUse"
                >
                    <stop offset={0.1} stopColor="#7c7c7e" />
                    <stop offset={0.3} stopColor="#a8a8aa" />
                    <stop offset={0.51} stopColor="#cecece" />
                    <stop offset={0.7} stopColor="#e9e9e9" />
                    <stop offset={0.87} stopColor="#f9f9f9" />
                    <stop offset={1} stopColor="#fff" />
                </linearGradient>
                <linearGradient
                    id="prefix__m"
                    x1={32.76}
                    y1={21.04}
                    x2={72.74}
                    y2={73.44}
                    gradientUnits="userSpaceOnUse"
                >
                    <stop offset={0} stopColor="#51267e" />
                    <stop offset={0.2} stopColor="#57257e" />
                    <stop offset={0.47} stopColor="#67237e" />
                    <stop offset={0.77} stopColor="#821f7f" />
                    <stop offset={1} stopColor="#9b1b7f" />
                </linearGradient>
                <linearGradient
                    id="prefix__b"
                    x1={61.28}
                    y1={96.89}
                    x2={61.28}
                    y2={130.87}
                    gradientUnits="userSpaceOnUse"
                >
                    <stop offset={0} stopColor="#232220" />
                    <stop offset={0.15} stopColor="#232220" />
                    <stop offset={1} stopColor="#232220" />
                </linearGradient>
                <linearGradient
                    id="prefix__n"
                    x1={90.24}
                    y1={96.89}
                    x2={90.24}
                    y2={130.87}
                    xlinkHref="#prefix__b"
                />
                <linearGradient
                    id="prefix__o"
                    x1={119.94}
                    y1={96.89}
                    x2={119.94}
                    y2={130.87}
                    xlinkHref="#prefix__b"
                />
                <linearGradient
                    id="prefix__p"
                    x1={154.42}
                    y1={96.89}
                    x2={154.42}
                    y2={130.87}
                    xlinkHref="#prefix__b"
                />
                <linearGradient
                    id="prefix__q"
                    x1={190.41}
                    y1={96.89}
                    x2={190.41}
                    y2={130.87}
                    xlinkHref="#prefix__b"
                />
                <linearGradient
                    id="prefix__r"
                    x1={227.33}
                    y1={96.89}
                    x2={227.33}
                    y2={130.87}
                    xlinkHref="#prefix__b"
                />
                <linearGradient
                    id="prefix__s"
                    x1={261.07}
                    y1={96.89}
                    x2={261.07}
                    y2={130.87}
                    xlinkHref="#prefix__b"
                />
                <linearGradient
                    id="prefix__t"
                    x1={291.24}
                    y1={96.89}
                    x2={291.24}
                    y2={130.87}
                    xlinkHref="#prefix__b"
                />
                <linearGradient
                    id="prefix__u"
                    x1={327.83}
                    y1={96.89}
                    x2={327.83}
                    y2={130.87}
                    xlinkHref="#prefix__b"
                />
                <linearGradient
                    id="prefix__v"
                    x1={360.65}
                    y1={96.89}
                    x2={360.65}
                    y2={130.87}
                    xlinkHref="#prefix__b"
                />
            </defs>
            <g data-name="Calque 1">
                <path fill="none" d="M0 0h422.01v165.13H0z" />
                <path
                    d="M110.89 39.17a5 5 0 00-4.76-3.54H99v49.29h11.87V39.17z"
                    fill="url(#prefix__c)"
                />
                <path
                    d="M110.89 41.16L99 41.18v18c4.06-1.84 8.78 12.49 8.78 12.49l3.09 8.81z"
                    style={{
                        mixBlendMode: "multiply",
                    }}
                    fill="url(#prefix__d)"
                />
                <path
                    d="M110.89 39.17a5 5 0 00-4.52-3.55H99v6.76c3.87-2.9 8.59 11.42 8.59 11.42l3.28 9.35v-24z"
                    fill="url(#prefix__e)"
                />
                <path
                    d="M180.57 53.3l.18.51 10.37 31.11H204l-16.1-46.29a5 5 0 00-4.42-3h-9l-2.34 6.76c3.45-2.57 7.55 8.39 8.43 10.91z"
                    fill="url(#prefix__f)"
                />
                <path
                    d="M180.57 53.3c-.88-2.52-5-13.48-8.41-10.91l-14.75 42.53h12.68l10.52-31.12h.13z"
                    fill="url(#prefix__g)"
                />
                <path
                    d="M180.57 53.3c-.88-2.52-5-13.48-8.41-10.91l-3 8.63a47.4 47.4 0 013.6 7.95l.17.51 2.86 8.57 4.82-14.25h.13z"
                    style={{
                        mixBlendMode: "multiply",
                    }}
                    fill="url(#prefix__a)"
                />
                <path
                    d="M150.1 35.63l-10.52 31.13h-.13l.17.5c.89 2.52 5 13.48 8.41 10.9l14.76-42.53z"
                    fill="url(#prefix__h)"
                />
                <path
                    d="M147.44 61.59l-.18-.52-2.86-8.57-4.82 14.26h-.13l-1.24 4 2.95 8.45h6.5l3.34-9.68a46.35 46.35 0 01-3.56-7.94z"
                    style={{
                        mixBlendMode: "multiply",
                    }}
                    fill="url(#prefix__i)"
                />
                <path
                    d="M139.62 67.26l-.18-.52-10.37-31.11h-12.89l16.12 46.29a5 5 0 004.41 3h9l2.29-6.76c-3.4 2.58-7.49-8.38-8.38-10.9z"
                    fill="url(#prefix__j)"
                />
                <path
                    d="M81.06 35.63L70.54 66.76h-.13l.17.5c.89 2.52 5 13.48 8.41 10.9l14.76-42.53z"
                    fill="url(#prefix__k)"
                />
                <path
                    d="M78.4 61.59l-.18-.52-2.86-8.57-4.82 14.26h-.13l-1.24 4 3 8.45h6.5L82 69.53a46.35 46.35 0 01-3.6-7.94z"
                    style={{
                        mixBlendMode: "multiply",
                    }}
                    fill="url(#prefix__l)"
                />
                <path
                    d="M70.58 67.26l-.17-.52L60 35.63H47.14l16.12 46.29a5 5 0 004.41 3h9L79 78.16c-3.44 2.58-7.53-8.38-8.42-10.9z"
                    fill="url(#prefix__m)"
                />
                <path
                    d="M57.22 104.39H47.14v-7.08h28.28v7.08H65.35v26.66h-8.13z"
                    fill="url(#prefix__b)"
                />
                <path
                    d="M79.51 97.31h20.81v7.08H87.64v6.13h10.12v7.08H87.64v6.4H101v7.08H79.51z"
                    fill="url(#prefix__n)"
                />
                <path
                    d="M122 96.74c8.22 0 12.45 4.77 12.45 4.77l-3.77 6.23s-3.71-3.45-8.31-3.45c-6.36 0-9.38 4.77-9.38 9.63s3.25 10.15 9.38 10.15c5 0 8.82-4.16 8.82-4.16l4.18 6a18.1 18.1 0 01-13.37 5.71c-10.4 0-17.42-7.51-17.42-17.51A17 17 0 01122 96.74z"
                    fill="url(#prefix__o)"
                />
                <path
                    d="M140.26 97.31h8.12v13.5h12.08v-13.5h8.13v33.74h-8.13v-13.21h-12.08v13.21h-8.12z"
                    fill="url(#prefix__p)"
                />
                <path
                    d="M176.39 97.31h8.22l9.19 15.76a61.47 61.47 0 012.79 5.76h.09s-.37-3.64-.37-5.76V97.31h8.13v33.74h-8.17L187 115.34a60.3 60.3 0 01-2.78-5.76h-.1s.38 3.63.38 5.76v15.71h-8.13z"
                    fill="url(#prefix__q)"
                />
                <path
                    d="M227.33 96.74A16.92 16.92 0 01244.7 114c0 9.91-7.33 17.65-17.37 17.65S210 123.88 210 114a16.92 16.92 0 0117.33-17.26zm0 27.33c5 0 9-4.34 9-10.1 0-5.52-4-9.68-9-9.68s-9 4.16-9 9.68c.04 5.76 4.04 10.1 9 10.1z"
                    fill="url(#prefix__r)"
                />
                <path
                    d="M250.23 97.31h8.13V124h13.56v7.08h-21.69z"
                    fill="url(#prefix__s)"
                />
                <path
                    d="M291.24 96.74A16.93 16.93 0 01308.61 114c0 9.91-7.34 17.65-17.37 17.65s-17.37-7.74-17.37-17.65a16.93 16.93 0 0117.37-17.26zm0 27.33c5 0 9-4.34 9-10.1 0-5.52-4-9.68-9-9.68s-9 4.16-9 9.68c.04 5.76 4.03 10.1 9 10.1z"
                    fill="url(#prefix__t)"
                />
                <path
                    d="M329.32 96.74c8.5 0 12.77 4.49 12.77 4.49l-3.9 6.18a13.1 13.1 0 00-8.08-3.12c-7 0-9.8 4.53-9.8 9.54 0 6.41 4.37 10.24 9.52 10.24a11.29 11.29 0 006.74-2.46V119h-4.7v-7h11.89v19.06H337v-.94-1.42h-.09a13.64 13.64 0 01-8.73 2.93c-8.5 0-16.3-6.47-16.3-17.51a16.94 16.94 0 0117.44-17.38z"
                    fill="url(#prefix__u)"
                />
                <path
                    d="M356.58 117.22l-11-19.91h9.24l3.77 8.12c1.06 2.31 2 4.86 2 4.86h.1s.92-2.55 2-4.86l3.72-8.12h9.24l-11 19.91v13.83h-8.13z"
                    fill="url(#prefix__v)"
                />
            </g>
        </svg>
    )
}

export default SvgComponent